import {
  Center,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { RanaButton } from "@nens/ranalib";
import { capitalizeFirst } from "@nens/shared-utils";

import { RanaMap } from "@/lib/rana-map";

import { Mode, useProcessRunFormDrawGeometry } from "../hooks/use-process-run-form-draw-geometry";

export interface ModeButtonProps extends ReturnType<typeof useProcessRunFormDrawGeometry> {
  buttonMode: Mode;
  index: number;
}
export const ModeButton = ({
  buttonMode,
  mode,
  modes,
  changeMode,
  index,
  somethingOnMap,
  modeAllowsMultiple,
}: ModeButtonProps) => {
  const { isOpen, onClose, onToggle } = useDisclosure();
  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="top">
      <RanaMap.MapButton
        roundL={!index}
        roundR={!modeAllowsMultiple || (index === modes.length - 1 && !somethingOnMap)}
        {...(mode === buttonMode ? { active: true } : { bg: "white" })}
        onClick={() => (somethingOnMap ? onToggle() : changeMode(buttonMode))}
        zIndex="docked"
        px={2}
      >
        <PopoverTrigger>
          <Center alignItems="center" h="small_button">
            {capitalizeFirst(buttonMode)}
          </Center>
        </PopoverTrigger>
      </RanaMap.MapButton>
      <PopoverContent>
        <PopoverHeader fontWeight="bold" borderWidth="0">
          <FormattedMessage
            id="process.switch_to_button_mode"
            defaultMessage="Switch to {buttonMode} mode?"
            values={{ buttonMode }}
          />
        </PopoverHeader>
        <PopoverArrow bg="brand.cloudy" />
        <PopoverCloseButton onClick={onClose} />
        <PopoverBody pt={0}>
          <Text>
            <FormattedMessage
              id="process.this_will_remove_all_modes"
              defaultMessage="This will remove all {mode}s"
              values={{ mode }}
            />
          </Text>
          <RanaButton
            mt={2}
            mx="auto"
            h="small_button"
            variant="primary"
            onClick={() => {
              onClose();
              changeMode(buttonMode);
            }}
          >
            <FormattedMessage id="button.switch" defaultMessage="Switch" />
          </RanaButton>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
